import { render, staticRenderFns } from "./detailsMembership.vue?vue&type=template&id=5aaea884&scoped=true"
import script from "./detailsMembership.vue?vue&type=script&lang=js"
export * from "./detailsMembership.vue?vue&type=script&lang=js"
import style0 from "./detailsMembership.vue?vue&type=style&index=0&id=5aaea884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaea884",
  null
  
)

export default component.exports